import React from 'react';
import { Link } from 'react-router';
import { filter, includes, flow, map, sortBy } from 'lodash';
import classNames from 'classnames';
import style from './style.module.less';
import Frame from '../Frame';
import ResponsiveImage from '../ResponsiveImage';

export default function ProjektList({ currentPath, pages }) {
    const projects = flow(
        pages => filter(pages, page => isProject(page, currentPath)),
        pages => sortBy(pages, page => page.data.order),
        pages => map(pages, Project)
    )(pages);

    return (
        <ul className={style.list}>
            {projects}
        </ul>
    );
}

function isProject(page, currentPath) {
    return page.path !== currentPath && includes(page.path, currentPath) && !includes(page.path, 'sidebar');
}

function Project(project, idx) {
    const { path } = project;

    let backgroundImage = undefined;

    if (project.data.headImage) {
        backgroundImage = <ResponsiveImage source={'head/' + project.data.headImage} className={style.image} />;
    }

    return (
        <li key={path} className={style.project}>
            <Link to={path} className={style.link}>
                <Frame frameID={idx} className={style.frame}>
                    {backgroundImage}
                </Frame>
                {project.data.title}
            </Link>
        </li>
    );
}



// WEBPACK FOOTER //
// ../components/ProjectList/index.js